module.exports = __webpack_public_path__ + "static/img/middle4.b350c38.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/daoba-match/assets/orgextension/middle4.jpg
// module id = +D9s
// module chunks = 9